import React from "react";
import { StyleSheet, View } from "react-native-web";
import { Values } from "../../../../config";
import { Media } from "../../../../components/molecules";
import { useSwipeable } from "react-swipeable";

const MediaContainer = (props) => {
  const { isMobileVersion, item, onPrev, onNext } = props;
  const handlers = useSwipeable({
    onSwipedLeft: (eventData) => {
      onNext();
    },
    onSwipedRight: (eventData) => {
      onPrev();
    },
  });

  return (
    <View style={[styles.container, props.style]}>
      <Media
        style={{ marginTop: isMobileVersion ? 0 : 30 }}
        isAutoHeight
        width={isMobileVersion ? Values.deviceWidth - 100 : 870}
        height={isMobileVersion ? 600 : 600}
        item={item}
        isPlay={true}
        isFull={true}
      />
      <div
        {...handlers}
        className="absolute z-10 h-full w-full flex flex-row justify-between items-center px-[15px]">
        <div className="cursor-pointer" onClick={onPrev}>
          <img
            src={
              isMobileVersion
                ? "/icons/ic_arrow_left_white.png"
                : "/icons/ic_arrow_left.png"
            }
            width="40"
            height="40"
            alt="arrow"
          />
        </div>
        <div className="cursor-pointer" onClick={onNext}>
          <img
            src={
              isMobileVersion
                ? "/icons/ic_arrow_right_white.png"
                : "/icons/ic_arrow_right.png"
            }
            width="40"
            height="40"
            alt="arrow"
          />
        </div>
      </div>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch",
  },
});

export default MediaContainer;
